import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { FormControl, FormGroup } from '@angular/forms';
import { StarState, StarStateStruct } from '../review-star-item/review-star-item.component';
import { Comment } from 'src/app/core/interfaces/movie.model';
import { MoviesService } from 'src/app/core/services/movies.service';
import * as moment from 'moment';
import Swal from 'sweetalert2';
import { Router } from '@angular/router';

@Component({
  selector: 'app-new-comment-item',
  templateUrl: './new-comment-item.component.html',
  styleUrls: ['./new-comment-item.component.scss']
})
export class NewCommentItemComponent implements OnInit {
  @Input() authorId: number;
  @Input() filmId: number;
  @Output() onCommented = new EventEmitter<any>();

  commentForm: FormGroup;
  currentScore: number = 0;
  starStates: StarStateStruct[] = [];

  loading = false;
  showResetStars = false;

  constructor(
    private moviesService: MoviesService,
    private router: Router,
  ) {
    this.commentForm = new FormGroup({
      comment: new FormControl(""),
    })
  }

  ngOnInit(): void {
    this.prepararDatos();
  }

  onClickEnviar(e: any) {
    this.loading = true;

    let newComment: Comment = {
      userId: this.authorId,
      MovieId: this.filmId,
      createdTime: new Date(moment().format('YYYY-MM-DDTHH:mm:ss')),
      comment: this.commentForm.get("comment").value,
      State: 1,
      ParentId: 0,
      isReview: true,
      score: this.currentScore,
    }

    this.moviesService.publishComment(newComment).subscribe((res) => {
      Swal.fire({
        icon: 'success',
        text: "Comentario publicado correctamente.",
        confirmButtonText: 'Ok',
        confirmButtonColor: 'green'
      })
      this.resetearDatos();
    },
      (error) => {
        Swal.fire('Ups!', 'Ha ocurrido un error en la conexión. Intente nuevamente en unos minutos.', 'error');
      },
      () => this.loading = false
    );

  }

  resetearDatos() {
    this.starStates.forEach((s, index) => {
      s.state = StarState.empty;
      s.isSelected = false;
      s.isHovered = false;
    });
    this.commentForm.get("comment").setValue("");
    this.currentScore = 0;
    this.onCommented.next();
  }

  prepararDatos() {
    for (let i = 0; i < 5; i++) {
      let s: StarStateStruct = {
        id: i,
        state: StarState.empty,
        isSelected: false,
        isHovered: false,
      }
      this.starStates.push(s);
    }
  }

  onStarHovered(e: StarStateStruct) {
    this.starStates.forEach((s, index) => {
      s.state = StarState.empty;
      s.isSelected = false;
      s.isHovered = false;
      if (index < e.id) {
        s.state = StarState.full;
        s.isSelected = false;
        s.isHovered = true;
      }
    });

    this.starStates[e.id].state = e.state;
    this.starStates[e.id].isSelected = false;
    this.starStates[e.id].isHovered = true;
  }

  onStarSelected(e: StarStateStruct) {

    this.showResetStars = true;

    this.starStates.forEach((s, index) => {
      s.state = StarState.empty;
      s.isSelected = false;
      s.isHovered = false;
      if (index < e.id) {
        s.state = StarState.full;
        s.isSelected = true;
        s.isHovered = false;
      }
    });

    this.starStates[e.id].state = e.state;
    this.starStates[e.id].isSelected = true;
    this.starStates[e.id].isHovered = false;

    this.calculateScore(e.id, e.state)//Llamada para calcular el score correspondiente a la cantidad de estrellas.
  }

  calculateScore(lastIdSelected: number, state: StarState) {
    let score = lastIdSelected;//Aca pone el primer valor de score, la estrella de id 2 es la tercer estrella entonces el score por ahora es 2.
    if (state == StarState.half) {
      score = score + 0.5;//Aca le sumo el 0.5 correspondiente a la media estrella seleccionada.
    }
    else if (state == StarState.full) {
      score = score + 1;//Aca le sumo 1 correspondiente a la estrella completa seleccionada.
    }
    this.currentScore = score;
  }

  onResetStars() {
    this.showResetStars = false;

    this.starStates.forEach(s => {
      s.state = StarState.empty;
      s.isSelected = false;
      s.isHovered = false;
    });

    this.currentScore = 0;

  }

  public get StarState(): typeof StarState {
    return StarState;
  }

}
